import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { memo } from 'react';
import ToggleText from '~/components/ui/ToggleText';
import { formatToHumanReadableDate } from '~/lib/util';
import { isIndexablePage } from '~/lib/util/constants';

export interface IDiscussionQuestionInfo {
  comment: string;
  userName: string;
  publishDate: Date | number;
  detailUrl: string;
  commentClass?: string;
}

function DiscussionQuestionInfo({
  comment,
  userName,
  publishDate,
  detailUrl,
  commentClass,
}: Readonly<IDiscussionQuestionInfo>): JSX.Element {
  const { asPath } = useRouter();

  return (
    <div data-testid="discussion-question-info" className="space-y-1">
      <ToggleText
        text={`Q: ${comment}`}
        className={clsx(
          'font-header text-xl font-bold leading-6 text-black-pearl',
          commentClass ?? ''
        )}
      />
      <div className="flex flex-wrap items-center justify-between text-sm text-grace">
        <div className="flex items-center gap-2">
          <span className="font-semibold">{userName}</span>
          <span
            className="h-1.5 w-1.5 rounded-full bg-gravel"
            aria-hidden="true"
          />
          <span>
            {formatToHumanReadableDate(
              new Date(publishDate).toISOString(),
              {
                month: 'short',
              },
              'en-US',
            )}
          </span>
        </div>
        {!isIndexablePage(asPath.split('?')[0]) && (
          <Link
            className="text-slate hover:text-gray-500"
            href={detailUrl}
            target="_blank"
          >
            <span className="sr-only">See detail</span>
            <FontAwesomeIcon icon={faExternalLinkAlt} />
          </Link>
        )}
      </div>
    </div>
  );
}

export default memo(DiscussionQuestionInfo);
